import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { CoverImage } from "@/components";
import Image from "@/assets/cover/news_dbg.webp";
import SubmissionsFetcher from "@/features/submissions/components/submissions.fetcher";

const SubmissionsPage: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Submissions");

  return (
    <>
      <CoverImage
        src={Image}
        alt="CoverImage"
        heading="Submissions"
        desc="Manage your submissions here."
      />
      <SubmissionsFetcher />
    </>
  );
};

export default SubmissionsPage;
